import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Swiper from "swiper/bundle";
import { Fancybox } from "@fancyapps/ui";

import SectionRecentlyTimeline from "./SectionRecentlyTimeline";

export default class Section {
  constructor(dom) {
    window.addEventListener("resize", () => this.resize());
    this.dom = dom
  }

  init() {
    const type = this.dom.dataset.type

    switch (type) {
      case '_recently_timeline':
        // this.handleRecentlyTimeline()
        const sectionRecentlyTimeline = new SectionRecentlyTimeline(this.dom)
        sectionRecentlyTimeline.init()
        break;
      case '_programme_trailers':
        this.handleProgrammeTrailers()
        break;
      default:
        break;
    }
  }

  handleProgrammeTrailers() {
    console.log('handleProgrammeTrailers', this.dom.querySelectorAll('.trailer-item'));
    Fancybox.bind(this.dom, "[data-fancybox]", {
      // Your custom options
    });
  }

  initResponsiveHelper() {

  }

  resize() {
  }

}
